import React from "react";
import "../../Styles/certified/epiq.css";

export default function Finzly() {
  return (
    <>
      <div className="epiq-certified-details-section">
        <div className="epiq-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="epiq-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="epiq-certified-details-left">
            <img
              src="/assets/epiq/draft_ribbon.png"
              alt="Outstanding Workplaces Certified"
              className="epiq-certified-badge"
            />
            <div className="epiq-certified-company-names">
              <a href="https://epiqindia.com/" target="_blank" rel="noopener noreferrer">
              <img
                src="/assets/epiq/epiq.png"
                alt="Walkzero Logo"
                className="epiq-certified-company-logo"
              />
            </a>
              <h1 className="epiq-certified-full-name">
           Epiq India Support Services LLP
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="epiq-certified-details-right">
            <img
              src="/assets/epiq/epiq_2.jpeg"
              alt="Finzly Office"
              className="epiq-certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="epiq-certified-description">
          <h2>
            Why  Epiq India Support Services LLP is an Outstanding Workplaces
          </h2>
          <p>
          EPIQ India, based in Chennai, is a pioneering staff augmentation, recruitment, and staffing company that serves clients nationwide. As India's first technology-focused recruitment partner, EPIQ deeply understands the unique needs of the IT and manufacturing sectors from a technical perspective. This specialized industry knowledge allows the company to deliver superior consulting and staffing services compared to generalist firms.


          </p>
          <p>
            EPIQ India has achieved significant scale, having successfully placed over 20,000 candidates and 150 contractors in various roles throughout India. The company's extensive experience and understanding of technology skills position it as the premier partner for organizations seeking top talent in IT and manufacturing domains.
          </p>
          
        </div>
        {/* Info Cards Section */}
        <div className="epiq-certified-info-cards">
          <div className="epiq-certified-info-card">
            <div className="epiq-certified-info-title">COMPANY SIZE</div>
            <div className="epiq-certified-info-value">50 Employees</div>
          </div>
          <div className="epiq-certified-info-card">
            <div className="epiq-certified-info-title">INDUSTRY</div>
            <div className="epiq-certified-info-value">Recruitment & Staffing

</div>
          </div>
          <div className="epiq-certified-info-card">
            <div className="epiq-certified-info-title">CONNECT</div>
            <div className="epiq-certified-info-icons">
              <span className="epiq-certified-icon-round">
                <a href="https://epiqindia.com/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="epiq-certified-icon-round">
                <a href="https://www.linkedin.com/company/epiq-india-support-services-llp/?originalSubdomain=in" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              
            </div>
          </div>
          <div className="epiq-certified-info-card">
            <div className="epiq-certified-info-title">LOCATION (HQ)</div>
            <div className="epiq-certified-info-value">Chennai, Tamil Nadu</div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="epiq-certified-recognition-section">
          <h2 className="epiq-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="epiq-certified-recognition-badge">
            <img
              src="/assets/epiq/draft_ribbon.png"
              alt="Outstanding Workplaces Certified"
              className="epiq-certified-recognition-image"
            />
          </div>
          <div className="epiq-certified-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at Finzly Section */}
        <div className="epiq-certified-life-section">
          <h2 className="epiq-certified-life-title">
            Life at Epiq India Support Services LLP
          </h2>
          <div className="epiq-certified-life-gallery">
            <div className="epiq-certified-life-col">
              <img src="/assets/epiq/epiq_1.jpeg" alt="Office 1" className="epiq-certified-life-img" />
              <img src="/assets/epiq/epiq_3.png" alt="Team 1" className="epiq-certified-life-img" />
            </div>
            <div className="icom-certified-life-col epiq-certified-life-center">
              <img src="/assets/epiq/epiq_4.png" alt="Main Office" className="epiq-certified-life-img epiq-certified-life-img-large" />
            </div>
            <div className="epiq-certified-life-col">
              <img src="/assets/epiq/epiq_5.png" alt="Office 2" className="epiq-certified-life-img" />
              <img src="/assets/epiq/epiq_6.png" alt="Team 2" className="epiq-certified-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
